export const clickElementById = (id: string) => {
  const element = document.getElementById(id);

  if (element) {
    element.click();
  } else {
    console.warn(`Element with id "${id}" not found`);
  }
};
